<ion-content class="messages" *ngIf="authServ.isLogged; else isntLogged">
  <ion-grid>

    <ion-row class="logo">
      <ion-col size="9" offset="1.5">
        <ion-img [src]="dataServ.rData.dark_logo" *ngIf="dataServ.rData.dark_logo[0]"></ion-img>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size="12" class="top">
        <ion-icon name="mail-outline" color="primary"></ion-icon>
        <ion-text color="primary">
          <h1>{{'My Messages' | translate}}</h1>
        </ion-text>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size="12" class="messages-col">
        <ion-list>

          <ion-item class="live-chat-item" color="primary" *ngIf="authServ.profile && !dataServ.rData.guests_cannot_send_messages" (click)="modalServ.openChat(null, true)" detail>
            <ion-icon slot="start" name="headset-outline"></ion-icon>
            <ion-label text-wrap>
              <b class="live-chat">{{ liveSupportName | caption | translate }}</b> <br>
              <ion-text color="light" *ngIf="authServ.profile.chat_badge > 0">
              </ion-text>
            </ion-label>
            <ion-chip color="white" mode="ios" slot="end" *ngIf="authServ.profile.chat_badge > 0">
              <ion-label color="white">{{authServ.profile.chat_badge}}</ion-label>
            </ion-chip>
          </ion-item>

          <ng-container *ngFor="let chat of chatServ.chatHeaders">
            <ion-item
              (click)="chatServ.badge = chatServ.badge - chat.badge; chat.badge = 0; modalServ.openChat(chat, false)"
              detail>
              <ion-avatar slot="start">
                <img [src]="chat.image_url" />
              </ion-avatar>
              <ion-label text-wrap>
                <b>{{chat.description | caption | translate}}</b> <br>
                <ion-text color="medium">
                  <small
                    *ngIf="chat.name && chat.name !== (chat.description | caption | translate)">{{chat.name}}</small>
                  <small>{{chat.last_time | date:'dd/MM/yyyy HH:mm'}}</small>
                </ion-text>
              </ion-label>

              <ion-chip color="primary" mode="ios" slot="end" *ngIf="chat.badge > 0">
                <ion-label color="primary">{{chat.badge}}</ion-label>
              </ion-chip>
            </ion-item>
          </ng-container>
        </ion-list>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ng-template #isntLogged>
  <app-profile></app-profile>
</ng-template>